import { RgChildren as g, getRgObjectsOfType as t } from "@project-rouge/rg-core";
function f(i, l, n) {
  const r = g.Building.flatMap((e) => t(i, e)).filter((e) => e.data.level === n);
  return t(r, l);
}
export {
  f as getRgObjectsAtLevel
};
//# sourceMappingURL=index3.js.map
